// SHARED-008: Panel container component
import type { ReactNode } from 'react';

interface PanelProps {
  title?: string;
  glow?: boolean;
  className?: string;
  children: ReactNode;
}

export function Panel({ title, glow, className = '', children }: PanelProps) {
  return (
    <div className={`panel ${glow ? 'glow-border' : ''} ${className}`}>
      {title && <div className="panel-title">{title}</div>}
      {children}
    </div>
  );
}
